import { Link } from 'react-router-dom';
import { Pencil, Languages, Eye, Copy } from 'lucide-react';
import { Delete } from '../../../features/DeleteEntity/index.js';
import './ActionBar.css';

export const ActionBar = ({
  editLink,
  viewLink,
  localizationLink,
  onDelete,
  onCopy,
  children,
  className = '',
}) => {
  return (
    <div className={`action-bar ${className}`}>
      {viewLink && (
        <Link to={viewLink} className="action-bar__btn ui-icon-btn" title="Просмотр">
          <Eye size={16} />
        </Link>
      )}
      {localizationLink && (
        <Link to={localizationLink} className="action-bar__btn ui-icon-btn" title="Локализации">
          <Languages size={16} />
        </Link>
      )}
      {editLink && (
        <Link
          to={editLink}
          className="action-bar__btn action-bar__btn--edit ui-icon-btn"
          title="Редактировать"
        >
          <Pencil size={16} />
        </Link>
      )}
      {onCopy && (
        <button
          type="button"
          className="action-bar__btn ui-icon-btn"
          onClick={onCopy}
          title="Копировать"
        >
          <Copy size={16} />
        </button>
      )}
      {onDelete && (
        <Delete onConfirm={onDelete} size={16} />
      )}
      {children}
    </div>
  );
};

export const ActionButton = ({ icon: Icon, onClick, to, title, variant = 'default', children }) => {
  const className = `action-bar__btn ui-icon-btn action-bar__btn--${variant}`;
  
  if (to) {
    return (
      <Link to={to} className={className} title={title}>
        {Icon && <Icon size={16} />}
        {children}
      </Link>
    );
  }

  return (
    <button type="button" className={className} onClick={onClick} title={title}>
      {Icon && <Icon size={16} />}
      {children}
    </button>
  );
};

export default ActionBar;
